import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronGrabberHorizontalToward"><Path d="M5.25 16L9.25 12L5.25 8" stroke="currentColor" strokeLinecap="square"/><Path d="M18.75 16L14.75 12L18.75 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontalToward;
